import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './routing/app-routing.module';
import { AppComponent } from './app.component';

// library modules
import { AngularMaterialModule } from './library-modules/angular-material/angular-material.module';

// custom modules
import { ServicesModule } from './services/services.module';
import { ComponentsModule } from './components/components.module';
import { UseCasesModule } from './use-cases/use-cases.module';
import { HttpClientService, UiNotificationService } from './services';
import { AuthConfigModule } from './library-modules/auth-config.module';
import { RouterModule } from '@angular/router';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AngularMaterialModule,
    ServicesModule,
    ComponentsModule,
    UseCasesModule,
    AuthConfigModule,
    RouterModule
  ],
  providers: [
    { provide: 'IHttpClientService', useClass: HttpClientService },
    { provide: 'IUiNotificationService', useClass: UiNotificationService },
    {provide: LocationStrategy, useClass: HashLocationStrategy}
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
